/** Keys stored per (username, account, strategy) that are NOT filter/rating
 *  config. The Analysis "From" date is one: bulk cfg autosave used to dump the
 *  whole settings map onto whichever account was selected, copying the date
 *  across accounts. */
export const ANALYSIS_START_KEY = "analysis_start";

export function isAccountUiSetting(key: string): boolean {
  return key === ANALYSIS_START_KEY;
}

export function withoutAccountUiSettings<T extends { key: string }>(entries: T[]): T[] {
  return entries.filter((e) => !isAccountUiSetting(e.key));
}

export function cfgWithoutAccountUiSettings(
  cfg: Record<string, string>,
): { key: string; value: string }[] {
  return Object.entries(cfg)
    .filter(([key]) => !isAccountUiSetting(key))
    .map(([key, value]) => ({ key, value }));
}

/** Build a cfg map from account-settings / defaults rows, dropping UI-only keys. */
export function cfgFromEntries(entries: { key: string; value: string }[]): Record<string, string> {
  const cfg: Record<string, string> = {};
  for (const e of entries) {
    if (isAccountUiSetting(e.key)) continue;
    cfg[e.key] = e.value;
  }
  return cfg;
}

export function analysisStartFromRows(rows: { key: string; value: string }[]): string {
  return rows.find((r) => r.key === ANALYSIS_START_KEY)?.value ?? "";
}

export function omitAccountUiSettings(cfg: Record<string, string>): Record<string, string> {
  const next: Record<string, string> = {};
  for (const [key, value] of Object.entries(cfg)) {
    if (!isAccountUiSetting(key)) next[key] = value;
  }
  return next;
}
